import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';
import OverpaidWarningPopup from './OverpaidWarningPopup';

export default injectIntl(withRouter(OverpaidWarningPopup));
